export const INPUT_PROPS = {
    EMAIL: {
        LABEL: 'Email',
        PLACEHOLDER: 'Email address',
        CONTROLL_NAME: 'email',
    },
    PASSWORD: {
        LABEL: 'Password',
        PLACEHOLDER: 'Password',
        CONTROLL_NAME: 'password',
    },
    CONFIRM_PASSWORD: {
        LABEL: 'Confirm password',
        PLACEHOLDER: 'Confirm Password',
        CONTROLL_NAME: 'confirmPassword',
    },
    FIRST_NAME: {
        LABEL: 'First Name',
        PLACEHOLDER: 'First name',
        CONTROLL_NAME: 'firstName',
    },
    LAST_NAME: {
        LABEL: 'Last name',
        PLACEHOLDER: 'Last name',
        CONTROLL_NAME: 'lastName',
    },
    COMPANY: {
        LABEL: 'Company name',
        PLACEHOLDER: 'Company name',
        CONTROLL_NAME: 'companyName',
    },
    CURRENT_PASSWORD: {
        LABEL: 'Current Password',
        PLACEHOLDER: 'Password',
        CONTROLL_NAME: 'currentPassword',
    },
    NEW_PASSWORD: {
        LABEL: 'New Password',
        PLACEHOLDER: 'Password',
        CONTROLL_NAME: 'newPassword',
    },
    PHONE_NUMBER: {
        LABEL: 'Phone number',
        PLACEHOLDER: 'Phone number',
        CONTROLL_NAME: 'phoneNumber',
    },
    WEBSITE: {
        LABEL: 'Website',
        PLACEHOLDER: 'Enter your website',
        CONTROLL_NAME: 'website',
    },
};

export const expiredSubscriptionStatus = ['canceled', 'incomplete', 'past_due', 'unpaid', 'incomplete_expired'];

export const countries = [
    'af',
    'al',
    'dz',
    'as',
    'ad',
    'ao',
    'ai',
    'aq',
    'ag',
    'ar',
    'am',
    'aw',
    'au',
    'at',
    'az',
    'bs',
    'bh',
    'bd',
    'bb',
    'by',
    'be',
    'bz',
    'bj',
    'bm',
    'bt',
    'bo',
    'ba',
    'bw',
    'br',
    'bn',
    'bg',
    'bf',
    'bi',
    'cv',
    'kh',
    'cm',
    'ca',
    'ky',
    'cf',
    'td',
    'cl',
    'cn',
    'co',
    'km',
    'cg',
    'cd',
    'cr',
    'ci',
    'hr',
    'cu',
    'cy',
    'cz',
    'dk',
    'dj',
    'dm',
    'do',
    'ec',
    'eg',
    'sv',
    'gq',
    'er',
    'ee',
    'sz',
    'et',
    'fj',
    'fi',
    'fr',
    'ga',
    'gm',
    'ge',
    'de',
    'gh',
    'gr',
    'gd',
    'gt',
    'gn',
    'gw',
    'gy',
    'ht',
    'hn',
    'hu',
    'is',
    'in',
    'id',
    'ir',
    'iq',
    'ie',
    'il',
    'it',
    'jm',
    'jp',
    'jo',
    'kz',
    'ke',
    'ki',
    'kp',
    'kr',
    'kw',
    'kg',
    'la',
    'lv',
    'lb',
    'ls',
    'lr',
    'ly',
    'li',
    'lt',
    'lu',
    'mg',
    'mw',
    'my',
    'mv',
    'ml',
    'mt',
    'mh',
    'mr',
    'mu',
    'mx',
    'fm',
    'md',
    'mc',
    'mn',
    'me',
    'ma',
    'mz',
    'mm',
    'na',
    'nr',
    'np',
    'nl',
    'nz',
    'ni',
    'ne',
    'ng',
    'mk',
    'no',
    'om',
    'pk',
    'pw',
    'pa',
    'pg',
    'py',
    'pe',
    'ph',
    'pl',
    'pt',
    'qa',
    'ro',
    'ru',
    'rw',
    'kn',
    'lc',
    'vc',
    'ws',
    'sm',
    'st',
    'sa',
    'sn',
    'rs',
    'sc',
    'sl',
    'sg',
    'sk',
    'si',
    'sb',
    'so',
    'za',
    'ss',
    'es',
    'lk',
    'sd',
    'sr',
    'se',
    'ch',
    'sy',
    'tw',
    'tj',
    'tz',
    'th',
    'tl',
    'tg',
    'to',
    'tt',
    'tn',
    'tr',
    'tm',
    'tv',
    'ug',
    'ua',
    'ae',
    'gb',
    'us',
    'uy',
    'uz',
    'vu',
    'va',
    've',
    'vn',
    'ye',
    'zm',
    'zw',
];

export const SERVER_WS_URL = process.env.REACT_APP_SERVER_WS_URL;

export const LINK_REDIRECT_URL = process.env.REACT_APP_LINK_REDIRECT_URL;

export const FACEBOOK_ID = '7464692953629360';

export const LINKEDIN_CLIENT_SECRET = 'fOEJXNPv2yVPKJb0';
export const LINKEDIN_CLIENT_ID = '77yug1mpldqhfo';

export const LINKEDIN_CALLBACK_URL = LINK_REDIRECT_URL;

export const linkedinOAuthURL = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${LINKEDIN_CLIENT_ID}&redirect_uri=${encodeURIComponent(
    LINKEDIN_CALLBACK_URL
)}&scope=email%20profile%20w_member_social%20openid`;

export const variants = {
    Default: 0,
    Agent: 1,
    Hollow: 2,
};

export const planTitles = {
    BUSISNESS_LITE: 'Business Lite',
    PRO: 'Pro',
    PLUS: 'Plus',
};

export const stripeKey =
    ['app.', 'live.', 'web.'].some((sub) => window.location.href.includes(sub)) && !window.location.href.includes('dev')
        ? 'pk_live_51MxzXfHs6pCZOyZi1wxtjZ3QQLrYbQdU7oW3IZKmRLFpIgOGgUbDkG7Ae9wKOYkcrFAA8P9gjy5na3e8a2bUUIUj006WTSZHBM'
        : 'pk_test_51MxzXfHs6pCZOyZijHLxttBxyfjgvVusMzAcL6ZYLlAOw2jurp32g9iZHa591joNevJ69wPfrqfW8aaQh6AtZPA800zoFN8Cwj';


export const PHONE_TYPE = {
    LOCAL: 'Local',
    TOLL_FREE: 'Toll-free',
};
